import type { SignUpConfig } from '#types/config/components/dialog/signUp'
import type { RecursivePartial } from '#types/utils'

export default {
  isInterestsDependingOnNewsletter: true
} satisfies RecursivePartial<SignUpConfig>
